
import { mapGetters } from 'vuex'
import { address } from '~/util/string'

export default {
    props: {
        person: {
            type: Object,
            default: null
        },
        soa: {
            type: Object,
            default: null
        },
        skipSoa: {
            type: Boolean,
            default: false
        },
        soa60days: {
            type: [String, Object],
            default: null
        },
        titleClass: {
            type: String,
            default: 'text-primary'
        },
        titleHidden: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            signed: false,
            form: {
                role: 'beneficiary',
                typed_name: '',
                products: {
                    mapd: true,
                    pdp: true,
                    supp: true,
                    dental_vision_hearing: true
                },
                agent_name: ''
            },
        }
    },
    computed: {
        ...mapGetters([
            'agent'
        ]),
        signedAgentName () {
            return (this.csoa60days || this.csoa)?.agent_name || this.form.agent_name || ''
        },
        signedSoaDateTime () {
            return this.$moment((this.soa60days || this.soa)?.created).format('MMMM D, YYYY [at] h:mm A')
        },
        csoa60days () {
            return this.soa60days?.value ? this.soa60days.value : this.soa60days
        },
        csoa () {
            return this.soa?.value ? this.soa.value : this.soa
        },
        readonly () {
            return !!(this.csoa || this.signed || this.soa60days || this.skipSoa)
        },
        canSubmit () {
            if (this.canAgent) {
                return false
            }
            return this.form.typed_name
        },
        personFullName () {
            return this.titlelize(this.csoa?.full_name || (this.person?.first_name + ' ' + this.person?.last_name))
        },
        personAddress () {
            return this.csoa?.address || this.person?.c_address || address(this.person)
        },
        personPhone () {
            return this.csoa?.phone || this.person?.phone || this.person?.cell_phone || this.person?.home_phone
        },
        isPdpOnly () {
            return this.form.products.pdp && !this.form.products.mapd && !this.form.products.supp && !this.form.products.dental_vision_hearing
        }
    },
    mounted () {
        if (this.csoa) {
            this.form.typed_name = this.csoa?.typed_name || this.personFullName
            this.form.products = this.csoa?.products || this.form.products
            this.form.role = this.csoa?.role || this.form.role
        } else {
            // prefill typed name with person name when available
            this.form.typed_name = this.personFullName
        }
    },
    methods: {
        async submitSoa () {
            // agents signatures are autosigned
            if (!this.canSubmit) {
                this.$alert({ message: 'Please enter your full name and agree to the electronic signature statement.', variant: 'warning' })
                return
            }

            const payload = {
                full_name: this.personFullName,
                address: this.personAddress,
                phone: this.personPhone,
                client_id: this.person?.id,
                role: this.form.role,
                typed_name: this.form.typed_name,
                products: this.form.products,
            }

            this.$emit('signature', payload)
            this.signed = true

            if (!payload.client_id) {
                return
            }

            this.$store.dispatch('busy')

            // Use existing helper; replace the endpoint name if your API differs
            const resp = await this.$try('createSignedSoa', payload)
            if (resp.error) {
                this.signed = false
            }

            this.$store.dispatch('idle')
            if (!resp || resp.error) {
                this.$alert({ message: (resp && resp.error) ? resp.error : 'Failed to submit SOA. Please try again.', variant: 'danger' })
                return
            }
            if (resp.agent_name || resp.value?.agent_name) {
                this.form.agent_name = resp.agent_name || resp.value?.agent_name
            }
            this.$alert({ message: 'Signed SOA uploaded successfully', variant: 'success' })
            this.$emit('soa60daysUpdate', resp)
        }
    }
}
